import { FormHelp, Text } from '@zillow/constellation-10';

const getStrengthLevel = (length: number) => {
  if (length <= 300) return 'weak';
  if (length > 600 && length <= 900) return 'strong';
  return 'good'; // 301-600 or 900+
};

const PropertyDescriptionStrength = ({ description = '' }: { description: string }) => {
  const strengthLevel = getStrengthLevel(description.length);

  return (
    <FormHelp role="status" aria-live="polite">
      Description strength:&nbsp;
      {strengthLevel === 'weak' && (
        <Text textStyle="body-xs-bold" css={{ color: 'text.feedback.critical.strong' }}>
          Weak
        </Text>
      )}
      {strengthLevel === 'good' && (
        <Text textStyle="body-xs-bold" css={{ color: 'text.feedback.warning.strong' }}>
          Good
        </Text>
      )}
      {strengthLevel === 'strong' && (
        <Text textStyle="body-xs-bold" css={{ color: 'text.feedback.success.strong' }}>
          Strong
        </Text>
      )}
    </FormHelp>
  );
};

export default PropertyDescriptionStrength;
